/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-console */
/* eslint-disable complexity */
/**
 * 文本消息组件
 * 使用方：用户对话，群组对话
 * @author sunzhiguang
 * @date 2020/6/10
 */
import React, { useCallback, useEffect, useMemo, useState } from "react";
import classNames from "classnames";
import { MessageSendType } from "@/types/chat/enum";
import "./index.less";
import {
  ChatMessage,
  ChatMessagePlusEmitBody,
  ChatMessageType,
  MessageStatus,
  SessionType,
  TextChatMessageExt
} from "@/types/chat";
import ChatState, { UserState } from "@/types/chat/State";
import { connect } from "dva";
import {
  buildImageMessageBody,
  convertContentToArray,
  getDisplayLink,
  getMessageTypeByText,
  initChatMessageInfo,
  isCrossPlatformGroupSession,
  isEqualEmployee,
  isOuterContacts,
  isShowAlias,
  MessageCardType,
  parseExtraContentToArray
} from "@/utils/chat/message";
import { useTranslation } from "react-i18next";
import { UserCardPayload } from "@/models";
import { getTextMessageContent } from "../../utils/commonMessageModal";
import { UserCardData } from "@/types/UserCard";
import Context from "@/components/chat/context";
import { EBookSubDeptInfo } from "@/models/ebook";
import ReplyMessage from "../ReplyMessage";
import JoyspaceTopic from "@/components/chat/message/message-components/JoyspaceTopic";
import ShortLink from "@/components/chat/message/message-components/ShortLink";
import { formatAtName, handleOpenMentionUserInfo } from "@/utils/chat/index";

import IconFont from "@/components/icon";
import { useHistory } from "react-router-dom";
import Image from "@/components/chat/message/Image";
import DotLoading from "@/baseComponents/DotLoading";
import { cancelMergeTag } from "@/components/Tags";
import AiLoading from "@/baseComponents/Chat/AILoading";
import AiUserLink from "@/baseComponents/Chat/AIUserLink";
interface TextProps {
  sText?: string;
  sMid?: number;
  message: TextChatMessageExt; // 发送消息内容
  sessionType: SessionType;
  sendType: MessageSendType;
  beginSend?: boolean;
  messageExtend?: any;
  isMergeForward?: boolean;
  isInviteForward?: boolean;
  curSearchMessgae?: any;
  searchKey?: string;
  isShowTag?: boolean;
  isPushUrl?: boolean;
  pushText?: string;
  pushMid?: number;
  onReady: (params: { beginSend: boolean; messageExtend: any }) => {};
  noSupportPre?: boolean;
  noPreAndNext?: boolean;
  notShowReply?: boolean;
  modalMessages?: any[];
}

interface DvaDispatchProps {
  unLock: Function;
  toggleUserCardModal: (payload: UserCardPayload) => void;
  getEbookDeptInfo: (params: any) => void;
  setStartMessageId: Function;
}

export type ITextProps = Readonly<
  TextProps & UserState & DvaDispatchProps & ChatState & EBookSubDeptInfo & UserCardData
>;
function mapStateToProps({ chat }: { chat: ChatState }) {
  const { currentEmployee, selectedSession, connectState } = chat;
  return {
    userInfo: currentEmployee,
    currentEmployee,
    selectedSession,
    connectState
  };
}
function Text(props: ITextProps) {
  const {
    sendType,
    message,
    onReady,
    selectedSession,
    sText = "",
    sMid = -1,
    isMergeForward,
    isInviteForward,
    curSearchMessgae,
    searchKey,
    isShowTag,
    pushText,
    pushMid,
    isPushUrl,
    setStartMessageId,
    noSupportPre,
    noPreAndNext,
    notShowReply,
    modalMessages
  } = props;
  const { groupRosterIdentity, currentEmployee, httpMatchUrls, blackUrls } = React.useContext(
    Context
  );
  const { t } = useTranslation("chat");
  const [isHighLight, setIsHighLight] = useState(false);
  const [isAtContent, setIsAtContent] = useState(false);
  const isSelf = isEqualEmployee(message.sender, currentEmployee);
  const history = useHistory();
  const hasRemark = useMemo(() => {
    let flag = false;
    if (message.atUsers) {
      for (let atUser of message.atUsers) {
        if (atUser.remark) {
          flag = true;
          break;
        }
      }
    }
    return flag;
  }, [message]);

  const dealImageData = (data: any) => {
    const chatMessage = initChatMessageInfo({
      selectedSession: selectedSession,
      currentEmployee: currentEmployee,
      message: {
        ...message,
        isOriginal: true,
        url: data.url,
        size: data.size,
        width: data.width,
        height: data.height,
        type: ChatMessageType.TEXT,
        fileMd5: data.fileMd5,
        imageId: `${message.mid || (message as any).muuid}-${data.imageId}`,
        fileName: data.title
      } as any
    });
    return {
      message: chatMessage
    };
  };

  const dealStyle = (attributes: any) => {
    if (!attributes) {
      return;
    }
    const style: any = {
      fontSize: "14px"
    };
    if (attributes?.size === "huge") {
      style.fontSize = "18px";
    } else if (attributes?.size === "large") {
      style.fontSize = "16px";
    }
    if (attributes?.italic === true) {
      style.fontStyle = "italic";
    }
    if (attributes?.bold === true) {
      style.fontWeight = "bold";
    }
    if (attributes?.strike === true) {
      style.textDecoration = "line-through";
    }
    if (attributes?.color) {
      style.color = attributes?.color;
    }
    return style;
  }

  const getRichText = () => {
    let displayRichContent: any[] = [];
    let displayRichText: any;
    let richText;
    if (typeof message.quillJson === "string") {
      richText = JSON.parse(message.quillJson);
    } else {
      richText = message.quillJson;
    }
    let count = 1;
    function mergeListsAndContent(delta: any) {
      let listItem: any = [];
      let newDelta: any = [];
      let listContent = "";
      if (delta[delta.length - 1]?.insert === "\n" && !delta[delta.length - 1]?.attributes) {
        delta = delta.slice(0, -1);
      }
      delta.forEach((item: any) => {
        const listType = item.attributes?.list;
        if (listType === "bullet" || listType === "ordered") {
          if (newDelta.length) {
            listContent = listType === "bullet" ? " " : `${count}. `;
          } else {
            listContent = listType === "bullet" ? " " : `${count}. `;
          }
          newDelta.push(
            { insert: listContent, list: listType, style: { color: "#1686FF" } },
            ...listItem,
            { insert: "\n" }
          );
          if (listType === "ordered") {
            count++;
          } else {
            count = 1;
          }
          listItem = [];
        } else {
          if (typeof item.insert === "string" && item.insert.indexOf("\n") > -1) {
            const lastNewlineIndex = item.insert.lastIndexOf("\n");
            const firstPart = item.insert.substring(0, lastNewlineIndex + 1);
            const secondPart = item.insert.substring(lastNewlineIndex + 1);
            count = 1;
            if (listItem?.length) {
              newDelta.push(...listItem, { ...item, insert: firstPart });
            } else {
              newDelta.push({ ...item, insert: firstPart });
            }
            listItem = [];
            if (secondPart) {
              listItem.push({ ...item, insert: secondPart });
            }
          } else {
            listItem.push(item);
          }
        }
      });
      newDelta.push(...listItem);
      return newDelta;
    }
    const newDelta = mergeListsAndContent(richText);
    let dealRes;
    let atNum = 0;
    for (const [index, item] of newDelta.entries()) {
      switch (typeof item.insert) {
        case "string":
          if (item?.list) {
            displayRichContent.push({
              type: MessageCardType.List,
              content: item.insert,
              ...item
            });
            break;
          }
          if (item?.insert === "\n") {
            if (!displayRichContent?.length ||
              displayRichContent[displayRichContent.length - 1]?.type === MessageCardType.JoyspaceTopic ||
              index === newDelta.length - 1
            ) {
              break;
            }
            displayRichContent.push({
              type: MessageCardType.Text,
              content: item.insert
            });
            break;
          }
          displayRichText = getDisplayLink(item.insert, message?.displayContent);
          displayRichText.map((content: any) => {
            return Object.assign(content || {}, { style: dealStyle(item?.attributes) });
          });
          displayRichContent.push(...displayRichText);
          break;
        case "object":
          // eslint-disable-next-line no-case-declarations
          const obj: any = item.insert;
          if (obj["mention-link"]) {
            const value = obj["mention-link"];
            let alias = "";
            if (isShowAlias(selectedSession)) {
              alias = value.alias;
            }
            displayRichContent.push({
              type: MessageCardType.Text,
              content: formatAtName(value.name || value.nickname, alias),
              atContent: formatAtName(value.name || value.nickname, alias),
              atDetail: value,
              style: dealStyle(item?.attributes)
            });
            atNum++;
          }
          if (obj["custom-emoji"]) {
            const value = obj["custom-emoji"];
            displayRichContent.push({ type: MessageCardType.Text, content: value });
          }
          if (obj["image"]) {
            const value = obj["image"];
            dealRes = dealImageData(value);
            displayRichContent.push({ type: MessageCardType.Image, content: dealRes });
          }
          break;
        default:
          break;
      }
    }
    return displayRichContent;
  };

  const getRealContent = useMemo(() => {
    const msg: any = message;
    if (msg?.quillJson?.length) {
      isShowAlias(selectedSession) || hasRemark ? setIsAtContent(true) : setIsAtContent(false);
      const content = getRichText();
      return content;
    }
    if (message.displayContent && message.displayContent.length > 0) {
      isShowAlias(selectedSession) || hasRemark ? setIsAtContent(true) : setIsAtContent(false);
      return message.displayContent;
    }
    setIsAtContent(false);
    const content =
      (isShowAlias(selectedSession) || hasRemark) && message.atContent
        ? message.atContent
        : message.content;
    // 处理人员气泡
    if (msg?.intentData?.extraInfo && !msg?.atContent && !msg?.atUsers?.length) {
      return parseExtraContentToArray(msg);
    }
    return convertContentToArray(content, message.data);
  }, [message, selectedSession, hasRemark]);

  useEffect(() => {
    const tempMid = curSearchMessgae ? curSearchMessgae.mid : sMid;
    const keyword = searchKey || sText;
    if (tempMid === message.mid && keyword) {
      setIsHighLight(true);
      setTimeout(() => {
        setIsHighLight(false);
      }, 3000);
    } else {
      setIsHighLight(false);
    }
  }, [curSearchMessgae, message.mid, sMid, sText, searchKey]);

  const getClass = useCallback(() => {
    return classNames({
      message: true,
      "text-message": true
      // owner: sendType === MessageSendType.OWNER,
    });
  }, []);

  useEffect(() => {
    if (
      (sendType === MessageSendType.OWNER || sendType === MessageSendType.SELF) &&
      message.status === MessageStatus.INIT
    ) {
      onReady({ beginSend: true, messageExtend: {} });
    }
  }, [sendType, message, onReady]);
  // if (!message.reply || (message.reply && message.replyMsgs) || isMergeForward) {
  return (
    <div className="content">
      {/* tag=1且是群聊才有这个icon */}
      {!notShowReply && selectedSession.isGroup && isSelf && isShowTag && message?.tag === 1 && (
        <IconFont
          style={{
            color: "#EE0A24",
            transform: "translate(10px,-4px)",
            width: 14,
            height: 14
          }}
          type="iconic_app_mark_solid_right"
        />
      )}
      <div
        className={getClass()}
        style={message?.style?.pc}
        onClick={(e) =>
          handleOpenMentionUserInfo(e, t, {
            currentEmployee,
            selectedSession,
            groupRosterIdentity,
            history,
            pushMid,
            pushText,
            isPushUrl,
            setStartMessageId
          })
        }
      >
        {!notShowReply && <ReplyMessage message={message} sendType={sendType} />}
        {/* <p
                    style={{
                        wordBreak: 'break-word',
                        display: 'flex',
                        alignItems: 'center',
                        flexWrap: 'wrap',
                    }}
                    dangerouslySetInnerHTML={{
                        __html: getTextMessageContent(message, currentEmployee, sText, sMid),
                    }}
                /> */}
        {getRealContent.map((item: any, index: number) => {
          return (
            <span key={index} style={{ margin: "1px 0" }}>
              {item.type === MessageCardType.Text ? (
                <span
                  className={`top-box ${selectedSession.isSecret ? "top-box_isSecret" : ""}`}
                  style={item?.style ? item.style : {}}
                  dangerouslySetInnerHTML={{
                    __html: getTextMessageContent(
                      selectedSession,
                      {
                        ...message,
                        content: isAtContent && item.atContent ? item.atContent : item.content
                      },
                      currentEmployee,
                      isHighLight ? (searchKey ? searchKey : sText) : "",
                      isHighLight ? (curSearchMessgae ? curSearchMessgae.mid : sMid) : -1,
                      item?.atDetail
                    )
                  }}
                />
              ) : item.type === MessageCardType.List ? (
                <span
                  className={`text-list ${item.list}`}
                  style={item?.style ? item.style : {}}
                  dangerouslySetInnerHTML={{
                    __html: `${item.content}`
                  }}
                />
              ) : item.type === MessageCardType.Image ? (
                item.content?.message ? (
                  <div className="text-image">
                    <Image
                      {...item.content}
                      noSupportPre={noSupportPre}
                      noPreAndNext={noPreAndNext}
                      isMergeForward={isMergeForward}
                      modalMessages={modalMessages}
                      isInviteForward={isInviteForward}
                    />
                  </div>
                ) : (
                  <span />
                )
              ) : item.type === MessageCardType.JoyspaceTopic ? (
                <JoyspaceTopic
                  content={item}
                  {...props}
                  isMergeForward={isMergeForward}
                  style={item?.style ? item.style : {}}
                />
              ) : item.type === MessageCardType.UserLink ? (
                <AiUserLink {...item} />
              ) : (
                <ShortLink
                  showTitle={item.type === MessageCardType.HttpTopic}
                  shortLinkItem={item}
                  searchKey={isHighLight ? (searchKey ? searchKey : sText) : ""}
                  curSearchMid={isHighLight ? (curSearchMessgae ? curSearchMessgae.mid : sMid) : -1}
                  curMessageMid={message.mid}
                  style={item?.style ? item.style : {}}
                />
              )}
            </span>
          );
        })}
      </div>
      {!notShowReply && selectedSession.isGroup && !isSelf && message?.tag === 1 && isShowTag && (
        <IconFont
          style={{
            color: "#EE0A24",
            transform: "translate(-9px,-4px)",
            width: 14,
            height: 14
          }}
          type="iconic_app_mark_solid_left"
        />
      )}
    </div>
  );
  // }
  // return null;
}
function mapDispatchToProps(dispatch: any) {
  return {
    toggleUserCardModal(payload: UserCardPayload) {
      dispatch({ type: "app/toggleUserCardModal", payload });
    },
    getEbookDeptInfo(data: any) {
      dispatch({ type: "ebook/getEbookDeptInfo", payload: data });
    },
    setStartMessageId(data: { sMid: number; sText: string }) {
      dispatch({ type: "chat/setStartMessageId", payload: data });
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Text);
